import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  createTransaction,
  editInactive,
  fetchBalance,
  updateTransaction,
} from "../features/transaction/transactionSlice";
import LoadingSpinner from "./LoadingSpinner";
// import idGen from "./../utilities/IdGen";

const Form = () => {
  //local states
  const [name, setName] = useState("");
  const [type, setType] = useState("");
  const [amount, setAmount] = useState(0);
  const [editMode, setEditMode] = useState(false);

  // redux hooks
  const dispatch = useDispatch();
  const { editing, loading, error } = useSelector((state) => state.transaction);
  const { isLoading, loadingType } = loading;
  const { isError, errorType, errorMsg } = error;

  useEffect(() => {
    const { id, name, type, amount } = editing;
    if (id) {
      setEditMode(true);
      setName(name);
      setType(type);
      setAmount(amount);
    } else {
      formReset();
      setEditMode(false);
    }
  }, [editing]);

  const handleCreate = async (e) => {
    e.preventDefault();

    await dispatch(createTransaction({ name, type, amount: Number(amount) }));
    dispatch(fetchBalance());
    formReset();
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    await dispatch(updateTransaction({ id: editing.id, data: { id: editing.id, name, type, amount: Number(amount) } }));
    dispatch(editInactive());
    dispatch(fetchBalance());
    formReset();
  };

  const formReset = () => {
    setName("");
    setAmount(0);
    setType("");
  };

  const cancelEditMode = () => {
    setEditMode(false);
    formReset();
    dispatch(editInactive());
  };
  return (
    <div className='form'>
      <h3>Add new transaction</h3>
      <form onSubmit={editMode ? handleUpdate : handleCreate}>
        <div className='form-group'>
          <label>Name</label>
          <input
            required
            className='form-input'
            type='text'
            name='transaction_name'
            placeholder='Enter Transaction name'
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </div>

        <div className='form-group radio'>
          <label>Type</label>
          <div className='radio_group'>
            <input
              required
              type='radio'
              id='type_income'
              value='income'
              name='type'
              checked={type === "income"}
              onChange={(e) => setType(e.target.value)}
            />
            <label htmlFor='type_income'>Income</label>
          </div>
          <div className='radio_group'>
            <input
              required
              id='type_expense'
              type='radio'
              value='expense'
              name='type'
              checked={type === "expense"}
              onChange={(e) => setType(e.target.value)}
            />
            <label htmlFor='type_expense'>Expense</label>
          </div>
        </div>

        <div className='form-group'>
          <label htmlFor='transaction_amount'>Amount</label>
          <input
            required
            className='form-input'
            type='number'
            placeholder='Enter Amount'
            name='transaction_amount'
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
          />
        </div>
        {(!isLoading && isError && errorType === "createError") ||
          (errorType === "updateError" && <p className='error'>{errorMsg}</p>)}
        <button disabled={isLoading} className='btn' type='submit'>
          {isLoading && (loadingType === "createTransaction" || loadingType === "updateTransaction") ? (
            <LoadingSpinner size='xsm' />
          ) : editMode ? (
            "Update Transaction"
          ) : (
            "Add Transaction"
          )}
        </button>
      </form>
      {editMode && (
        <button className='btn cancel_edit' onClick={cancelEditMode}>
          Cancel Edit
        </button>
      )}
    </div>
  );
};

export default Form;
